"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initNoibuSDK = void 0;
var errorhandler_1 = require("./errorhandler");
/**
 * Inits the Noibu Vue SDK
 * @param  {SDKOptions} sdkOptions
 * @returns void
 */
function initNoibuSDK(sdkOptions) {
    if (!sdkOptions.Vue && !sdkOptions.apps) {
        throw new Error('Need to pass at least the Vue or app property');
    }
    if (sdkOptions.apps) {
        sdkOptions.apps.forEach(function (app) { return (0, errorhandler_1.attachErrorHandler)(app); });
    }
    else if (sdkOptions.Vue) {
        (0, errorhandler_1.attachErrorHandler)(sdkOptions.Vue);
    }
}
exports.initNoibuSDK = initNoibuSDK;
